import template from './repositories.html';
class RepositoriesController {

}


export default {
    template: template,
    controller: RepositoriesController,
    bindings: {
        repositories: '='
    },
};


// WEBPACK FOOTER //
// ./views/repositories/repositories.controller.js